import toLowercase from '@/assets/js/toLowercase'

const parseFilter = filter => toLowercase(filter)

export default parseFilter



// WEBPACK FOOTER //
// ./src/assets/js/parseFilter.js